<template>
    <div class="panel-wrapper">
        <div class="container">
            <PatientSearchForm @search="getPatient" :anonymized="showAlert"></PatientSearchForm>

            <div v-if="patientFound" class="matrix-panel">
                <div class="table-layout table-patient table-clinician table-waiting table-search">
                    <div class="table-head head-fixed waiting-fixed">
                        <div class="table-tr">
                            <div class="table-th cell-length">{{ __('Patient') }}</div>
                            <div class="table-th cell-state">{{ __('Status') }}</div>
                            <div v-if="isDeTherapy" class="table-th cell-state">{{ __('Prescription') }}</div>
                            <div v-if="isDeTherapy" class="table-th cell-state">{{ __('Prescription will expire') }}</div>
                            <div class="table-th cell-invite">PATIENT / USER ID</div>
                            <div class="table-th cell-therapist">{{ __('Physician') }}</div>
                            <div class="table-th cell-therapist">{{ __('[m] Dietitian') }}</div>
                            <div class="table-th cell-institution">{{ __('Institution') }}</div>
                            <div class="table-th cell-link"></div>
                        </div>
                    </div>

                    <div class="table-body">
                        <PatientSearchRow v-for="(patient, index) in patients" :key="index" :patient="patient" @select="selectPatient"></PatientSearchRow>
                    </div>
                </div>
            </div>
        </div>

        <PatientModalAnonymize :userToAnonymize="patient" @success="patientAnonymized"></PatientModalAnonymize>
        <PatientModalFreemiumExtension :selectedUser="patient" @select="selectPatient"></PatientModalFreemiumExtension>
        <PatientModalFreemiumExtensionConfirm v-if="patient && patient.date" :freemiumExtension="patient" @success="freemiumExtended"></PatientModalFreemiumExtensionConfirm>

        <flash-alert v-if="showAlert" @closeAlert="close" :text="__(alertText)"></flash-alert>
    </div>
</template>

<script>
    import PatientSearchForm from './PatientSearchForm.vue'
    import PatientSearchRow from './PatientSearchRow.vue'
    import PatientModalAnonymize from './PatientModalAnonymize.vue'
    import PatientModalFreemiumExtension from './PatientModalFreemiumExtension.vue'
    import PatientModalFreemiumExtensionConfirm from './PatientModalFreemiumExtensionConfirm.vue'

    export default {
        components: {
            PatientSearchForm,
            PatientSearchRow,
            PatientModalAnonymize,
            PatientModalFreemiumExtension,
            PatientModalFreemiumExtensionConfirm
        },
        data() {
            return {
                patients: [],
                showAlert: false,
                alertText: '',
                patient: {
                    id: null,
                    fullname: null,
                    type: null,
                    date: null
                }
            }
        },
        async mounted() {
            $('.item-anonymize').addClass('active')
        },
        computed: {
            patientFound() {
                if (this.patients.length !== 0) {
                    return true
                }
            },
            isDeTherapy() {
                if (this.user.country === 'DE') {
                    return true
                }

                return false
            }
        },
        methods: {
            getPatient(patients) {
                if(patients.users) {
                    this.patients = patients.users.concat(patients.pending_patients)
                } else {
                    this.patients = []
                }
            },
            patientAnonymized(status) {
                if(status === true) {
                    this.showAlert = true
                    this.patients = this.patients.filter(p => p.mail !== this.patientEmail)
                    this.alertText = 'The patient has been anonymised and deactivated'
                } else {
                    this.close()
                }
            },
            selectPatient(patient) {
                this.patient = patient
            },
            close() {
                this.showAlert = false
            },
            freemiumExtended(status) {
                if(status === true) {
                    this.showAlert = true
                    this.alertText = 'Successful patient extension!'
                } else {
                    this.close()
                }
            },
        }
    }
</script>
